import React, { Fragment, useState } from "react";
import { Tabs, TabPanel } from "react-tabs"; // TabList,  Tab
import { Button, Form, FormGroup, Label } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { yupCategoryValidation } from "../../utils/authValidation";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import "../../assets/styles/admin.css";

const AddCategoryForm = ({ payload, setPayload }) => {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    // setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: payload || {},
    resolver: yupResolver(yupCategoryValidation()),
  });

  const [editData, setEditData] = useState();
  const [catType, setCatType] = useState(payload?.categoryType);
  const [singleClick, setSingleClick] = useState(false);

  const onSubmitHandler = async (data) => {
    const formData = new FormData();
    setSingleClick(true);
    delete data.logo;
    if (catType === "box") {
      delete data?.dontShowInStore;
    }
    Object.keys(data).map((el) => formData.append(el, data[el]));
    try {
      const { _id } = payload || {};
      console.log("data", errors);
      if (Object.keys(errors).length === 0) {
        if (_id) {
          const response = await adminInstance().put(
            `/api/admin/updateCategory/${_id}`,
            formData
          );
          const { code, msg } = response.data;

          setEditData({ ...editData, isUpdate: true });
          if (code === 200) {
            toast.success(msg, {
              toastId: 1,
            });
            reset();
            history.push("/category-list");
          } else {
            toast.error(msg, {
              toastId: 1,
            });
          }
        } else {
          const response = await adminInstance().post(
            "/api/admin/createCategory",
            formData
          );
          const { code, msg } = response.data;
          if (code === 200) {
            reset();
            toast.success(msg, {
              toastId: 1,
            });
            history.push("/category-list");
          } else {
            toast.error(msg, {
              toastId: 1,
            });
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Fragment>
      <Tabs>
        <TabPanel>
          <Form
            className="needs-validation user-add admin-type "
            onSubmit={handleSubmit(onSubmitHandler)}
          >
            {/* <h4>Add Category</h4> */}
            <FormGroup className="row justify-content-start mx-0">
              <div className="admin-input col-xl-5 col-md-7">
                <Label className="col-form-label pt-0">
                  <span>*</span> Name
                </Label>
                <input
                  {...register("name")}
                  className="form-control"
                  type="text"
                  defaultValue={payload.name || ""}
                />

                <p className="text-danger">{errors.name?.message}</p>
              </div>
            </FormGroup>
            <FormGroup>
              <Label className="col-form-label">Category Type</Label>
              <div className="m-checkbox-inline mb-0 custom-radio-ml d-flex radio-animated">
                <Label className="d-block">
                  <Label className="col-form-label">Case</Label>
                  <input
                    {...register("categoryType")}
                    type="radio"
                    value="box"
                    onClick={() => setCatType("box")}
                  />
                  <p className="text-danger">{errors.categoryType?.message}</p>
                  Active
                </Label>
                <Label className="d-block">
                  <Label className="col-form-label">Product</Label>
                  <input
                    {...register("categoryType")}
                    type="radio"
                    value="product"
                    defaultChecked
                    onClick={() => setCatType("product")}
                  />
                  <p className="text-danger">{errors.categoryType?.message}</p>
                  Deactive
                </Label>
              </div>
            </FormGroup>
            <div className="form-button d-flex justify-content-start pt-3">
              <Button color="primary" type="submit" disabled={singleClick}>
                Submit
              </Button>
            </div>
          </Form>
        </TabPanel>
      </Tabs>
    </Fragment>
  );
};
export default AddCategoryForm;
